import React, { Component } from 'react';
import { connect } from 'react-redux';
import SlideToggle from '@bit/knotchinc.web-react-components.slide-toggle';
import StoreSync from '@bit/knotchinc.web-react-components.store-sync';
import { fetchAlertSettings, updateAlertSetting, updateAlertRule } from 'actions/notifications.js';
import {
  AlertsContainer,
  AlertToggleContainer,
  ToggleBlock,
  ToggleText,
  AlertSection,
  Header,
  Title,
  SubAlertsContainer,
} from './styled';
import AlertRule from './AlertRule.jsx';

const SUB_RULE_HEIGHT = 98;

export const AlertsPanel = ({ alertSettings: { report }, changeAlertRule, changeAlertSetting }) => {
  const hasReportRules = report.rules && report.rules.length;

  return (
    <React.Fragment>
      <AlertSection>
        <Header>
          <Title type="report">Reports Notifications</Title>
          <AlertToggleContainer>
            <ToggleBlock mr="62px">
              <ToggleText>In-App Alerts</ToggleText>
              <SlideToggle
                toggled={report.dashboard_enabled}
                toggleHandler={() => changeAlertSetting({ alertType: 'report', format: 'dashboard_enabled', enabled: !report.dashboard_enabled })}
              />
            </ToggleBlock>
            <ToggleBlock>
              <ToggleText>Email Alerts</ToggleText>
              <SlideToggle
                toggled={report.email_enabled}
                toggleHandler={() => changeAlertSetting({ alertType: 'report', format: 'email_enabled', enabled: !report.email_enabled })}
              />
            </ToggleBlock>
          </AlertToggleContainer>
        </Header>
        <SubAlertsContainer rowHeight={hasReportRules ? report.rules.length * SUB_RULE_HEIGHT : 0} hide={!report.dashboard_enabled && !report.email_enabled}>
          {hasReportRules ?
          report.rules.map(alertType => <AlertRule alertType="report" changeAlertRule={changeAlertRule} data={alertType} />)
          : null
      }
        </SubAlertsContainer>
      </AlertSection>
      {/* <AlertSection>
    <Header>
      <Title>New Action Required</Title>
      <AlertToggleContainer>
        <ToggleBlock mr="62px">
          <ToggleText>In-App Alerts</ToggleText>
          <SlideToggle
            toggled={action.dashboard_enabled}
            toggleHandler={() => changeAlertSetting({ alertType: 'action', format: 'dashboard_enabled', enabled: !action.dashboard_enabled })}
          />
        </ToggleBlock>
        <ToggleBlock>
          <ToggleText>Email Alerts</ToggleText>
          <SlideToggle
            toggled={action.email_enabled}
            toggleHandler={() => changeAlertSetting({ alertType: 'action', format: 'email_enabled', enabled: !action.email_enabled })}
          />
        </ToggleBlock>
      </AlertToggleContainer>
    </Header>
    <SubAlertsContainer>
      {action.rules && action.rules.length ?
        action.rules.map(alertType => <AlertRule alertType="action" changeAlertRule={changeAlertRule} data={alertType} />)
        : null
      }
    </SubAlertsContainer>
  </AlertSection>
  <AlertSection>
    <Header>
      <Title>Insights Alerts</Title>
      <AlertToggleContainer>
        <ToggleBlock mr="62px">
          <ToggleText>In-App Alerts</ToggleText>
          <SlideToggle
            toggled={insight.dashboard_enabled}
            toggleHandler={() => changeAlertSetting({ alertType: 'insight', format: 'dashboard_enabled', enabled: !insight.dashboard_enabled })}
          />
        </ToggleBlock>
        <ToggleBlock>
          <ToggleText>Email Alerts</ToggleText>
          <SlideToggle
            toggled={insight.email_enabled}
            toggleHandler={() => changeAlertSetting({ alertType: 'insight', format: 'email_enabled', enabled: !insight.email_enabled })}
          />
        </ToggleBlock>
      </AlertToggleContainer>
    </Header>
    <SubAlertsContainer>
      {insight.rules && insight.rules.length ?
        insight.rules.map(alertType => <AlertRule alertType="insight" changeAlertRule={changeAlertRule} data={alertType} />)
        : null
      }
    </SubAlertsContainer>
  </AlertSection> */}
    </React.Fragment>);
};

export class AlertsPage extends Component {
  componentDidMount() {
    this.props.getAlertSettings();
  }

  render() {
    const { alertSettings, changeAlertSetting, changeAlertRule } = this.props;

    return (<AlertsContainer>
      <StoreSync stores={{ alertSettings }}>
        <AlertsPanel changeAlertSetting={changeAlertSetting} changeAlertRule={changeAlertRule} />
      </StoreSync>
    </AlertsContainer>);
  }
}

const mapStateToProps = ({ Notifications: { alertSettings } }) => ({
  alertSettings,
});

const mapDispatchToProps = dispatch => ({
  getAlertSettings: () => dispatch(fetchAlertSettings()),
  changeAlertSetting: ({ alertType, format, enabled }) => dispatch(updateAlertSetting({ alertType, format, enabled })),
  changeAlertRule: ({ alertType, rule_id, rule_enabled }) => dispatch(updateAlertRule({ alertType, rule_id, rule_enabled })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertsPage);
